import {createSlice} from '@reduxjs/toolkit';
import StorageHelper from '@core/helpers/storage-helpers/storage.helper';
import STORAGE_KEYS from '@core/helpers/storage-helpers/constants';

export interface IUserData {
  id: string;
  email: string;
  name: string;
  role: string;
  tenantId: string;
  accessPermissions?: string[];
}

interface IAuthState {
  user: IUserData | null;
  accessToken: string;
  isLoggedIn: boolean;
}

const initialState: IAuthState = {
  user: null,
  accessToken: '',
  isLoggedIn: false,
};

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, actions) {
      state.user = actions.payload;
      state.isLoggedIn = true;
    },
    logout(state) {
      state.accessToken = '';
      state.isLoggedIn = false;
      state.user = null;
      StorageHelper.remove(STORAGE_KEYS.ACCESS_TOKEN);
      StorageHelper.remove(STORAGE_KEYS.USER_ID);
      StorageHelper.remove(STORAGE_KEYS.TENANT_ID);
    },
    setAccessToken(state, actions) {
      state.accessToken = actions.payload;
    },
  },
});

const authReducer = auth.reducer;

export const authActions = auth.actions;

export default authReducer;
